import { render, staticRenderFns } from "./actionCustomClient.vue?vue&type=template&id=7e0959ce&"
import script from "./actionCustomClient.vue?vue&type=script&lang=js&"
export * from "./actionCustomClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports